module.exports = __webpack_public_path__ + "media/images/edit_wt-7702a7e2c24520e76d8d90275f76cf2d.png";